import { get, isObject } from 'lodash';
import constants from '../constants';

export class Or {
  constructor() {
    this.next = null;
  }

  setNext(handler) {
    this.next = handler;
    return handler;
  }

  handle(params) {
    const { token, context } = params;
    if (params?.token?.startsWith?.(constants.OR)) {
      const paths = token.slice(4);
      const [path1, path2] = paths.split(',');
      const value = get(context, path1.trim()) || get(context, path2.trim());
      if (value == null || (isObject(value) && value?.value == null)) {
        return constants.EMPTY;
      }
      return value;
    }

    return this?.next?.handle?.(params);
  }
}
